// import React from "react";
// import Navbar from "./Header";
// import Footer from "./Footer";

// const BoardManagement = () => {
//   return (
//     <>
//       <Navbar />
      
//       <div className="about-container">
//         {/* Key Management Section */}
//         <section className="management-section">
//           <h2 className="section-title">
//             <span className="title-decorator"></span>
//             Key Management
//           </h2>
          
//           <div className="desk-messages-container">
//             {/* Chairman's Message - Image Left */}
//             <div className="desk-message">
//               <div className="message-content-wrapper">
//                 <div className="member-img-container">
//                   <img src={require('../assets/Picture2.png')} alt="Shri Niranjan S Narasagoudar" />
//                 </div>
//                 <div className="message-content">
//                   <h3>From Chairman's Desk</h3>
//                   <h4>Shri. Niranjan S Narasagoudar</h4>
//                   <p className="position">Chairman, ASVEM School Shedbal</p>
//                   <div className="message-text">
//                     <p>We truly believe that education does not end in the class room, we take it beyond classroom. We create an environment that is exciting for our students to enhance learning opportunity. Keeping several learning methods in mind – we have upgraded our infrastructure, campus, added class rooms and improved our library and laboratories.</p>
//                     <p>We have an excellent faculty helping us to make a brilliant learning community for our students. Their expertise and dedication towards quality education and experiential learning has been preparing our children to become innovative, notable thinkers and enthused learners.</p>
//                   </div>
//                   <div className="message-signature">
//                     <p><strong>Best Regards</strong></p>
//                     <p>Shri. Niranjan Narasagoudar | Chairman, ASVEM School Shedbal</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Secretary's Message - Image Right */}
//             <div className="desk-message reverse-layout">
//               <div className="message-content-wrapper">
//                 <div className="member-img-container">
//                   <img src={require('../assets/Picture3.png')} alt="Shri Bahubali Sidnale" />
//                 </div>
//                 <div className="message-content">
//                   <h3>From Secretary's Desk</h3>
//                   <h4>Shri. Bahubali Sidnale</h4>
//                   <p className="position">Secretary, ASVEM School Shedbal</p>
//                   <div className="message-text">
//                     <p>I feel fortunate to be a part of ASVEM School committee. My heart is filled with immense pleasure as I perceive the progress being made by the school. We just believe in complete education for your children encompassing academics, co-curricular activities, sports education and life skills learning.</p>
//                     <p>My sincere advice to all the students that they have to work hard to face the global competition to survive. I request the teachers to maintain the team spirit and continue their efforts in giving the best to the students.</p>
//                   </div>
//                   <div className="message-signature">
//                     <p><strong>Best Wishes</strong></p>
//                     <p>Shri. Bahubali Sidnale | Secretary, ASVEM School Shedbal</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Vice-Chairman's Message - Image Left */}
//             <div className="desk-message">
//               <div className="message-content-wrapper">
//                 <div className="member-img-container">
//                   <img src={require('../assets/Picture4.png')} alt="Shri Dadasaheb Patil" />
//                 </div>
//                 <div className="message-content">
//                   <h3>From Vice-Chairman's Desk</h3>
//                   <h4>Shri. Dadasaheb Patil</h4>
//                   <p className="position">Vice-Chairman, ASVEM School Shedbal</p>
//                   <div className="message-text">
//                     <p>It is with great pleasure that I welcome you to ASVEM School family. As Vice Chairman, I am deeply committed to ensuring that our school continues to be a place where students can flourish academically and personally.</p>
//                     <p>Our mission is to provide a nurturing and stimulating environment where every student feels empowered to reach their full potential. We look forward to working in partnership with parents and faculty to build a brighter future for our students and our school.</p>
//                   </div>
//                   <div className="message-signature">
//                     <p><strong>Best Regards</strong></p>
//                     <p>Shri. Dadasaheb Patil | Vice-Chairman, ASVEM School Shedbal</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Principal's Message - Image Right */}
//             <div className="desk-message reverse-layout">
//               <div className="message-content-wrapper">
//                 <div className="member-img-container">
//                   <img src={require('../assets/Picture5.jpg')} alt="Mrs. Paddubai S K" />
//                 </div>
//                 <div className="message-content">
//                   <h3>From Principal's Desk</h3>
//                   <h4>Mrs. Paddubai S K</h4>
//                   <p className="position">Principal, ASVEM School Shedbal</p>
//                   <div className="message-text">
//                     <p>Education is an investment, and one of the most critical investments we can make. We live in a very challenging time where the world from the education window is changing like never before.</p>
//                     <p>At Acharya Shree Vidyanand English Medium School, we believe in a joyful experiential learning system wherein, each child is encouraged to participate wholeheartedly! We approach and imbibe the learning with global outlook and analytical thinking.</p>
//                   </div>
//                   <div className="message-signature">
//                     <p><strong>Best Wishes</strong></p>
//                     <p>Mrs. Paddubai S K | Principal, ASVEM School Shedbal</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>


//           <section className="board-section">
//           <h2 className="section-title">
//             <span className="title-decorator"></span>
//             Board of Management
//           </h2>
          
//           <div className="board-banner">
//             <img src={require('../assets/Picture7.png')} alt="Board of Management" />
//           </div>
          
//           <div className="board-names-container">
//             <div className="board-names-column">
//               <ul className="board-names">
//                 <li><span className="name">Shri Niranjan Narasagoudar</span> – Chairman</li>
//                 <li><span className="name">Shri Dadasaheb Patil</span> – Vice Chairman</li>
//                 <li><span className="name">Shri Bahubali Sidnale</span> – Secretary</li>
//                 <li><span className="name">Shri Shantinath Malaganve</span> – Member</li>
//                 <li><span className="name">Shri Roopesh Chougala</span> – Member</li>
//                 <li><span className="name">Shri Dhanyakumar Chougala</span> – Member</li>
//                 <li><span className="name">Shri Udaykumar Savadatti</span> – Member</li>
//               </ul>
//             </div>
            
//             <div className="board-names-column">
//               <ul className="board-names">
//                 <li><span className="name">Shri Sachin Lagare</span> – Member</li>
//                 <li><span className="name">Shri Deepak Lagare</span> – Member</li>
//                 <li><span className="name">Shri Pradeep Patil</span> – Member</li>
//                 <li><span className="name">Shri Sanjay Dargaj</span> – Member</li>
//                 <li><span className="name">Shri Sunil Iraj</span> – Member</li>
//                 <li><span className="name">Shri Praveen Patil</span> – Member</li>
//                 <li><span className="name">Shri Anandkumar Narasagoudar</span> – Member</li>
//               </ul>
//             </div>
//           </div>
//         </section>
//       </div>

//       <Footer />

//       <style>{`
//         /* Base Styles */
//         :root {
//           --primary-color: #0f2b6e;
//           --secondary-color: #f9a826;
//           --accent-color: #4a6fdc;
//           --light-bg: #f9fafc;
//           --dark-text: #333;
//           --light-text: #fff;
//           --card-shadow: 0 5px 15px rgba(0,0,0,0.1);
//           --transition: all 0.3s ease;
//         }
        
//         /* Section Title */
//         .section-title {
//           font-size: 2rem;
//           color: var(--primary-color);
//           margin-bottom: 2.5rem;
//           position: relative;
//           padding-left: 1.2rem;
//           text-align: center;
//         }
        
//         .title-decorator {
//           position: absolute;
//           left: 0;
//           top: 50%;
//           transform: translateY(-50%);
//           width: 6px;
//           height: 30px;
//           background: var(--secondary-color);
//           border-radius: 3px;
//         }
        
//         /* Desk Messages Container */
//         .desk-messages-container {
//           display: flex;
//           flex-direction: column;
//           gap: 3rem;
//           margin: 0 auto;
//           max-width: 1200px;
//           padding: 0 1rem;
//         }
        
//         /* Desk Message Card */
//         .desk-message {
//           background: white;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: var(--card-shadow);
//           transition: var(--transition);
//         }
        
//         .desk-message:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 10px 25px rgba(0,0,0,0.15);
//         }
        
//         /* Message Content Wrapper */
//         .message-content-wrapper {
//           display: flex;
//           min-height: 350px;
//         }
        
//         /* Reverse layout for alternating pattern */
//         .reverse-layout .message-content-wrapper {
//           flex-direction: row-reverse;
//         }
        
//         /* Member Image Container */
//         .member-img-container {
//           flex: 1;
//           min-width: 40%;
//           position: relative;
//           overflow: hidden;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }
        
//         .member-img-container img {
//           width: 60%;
//           height: 60%;
//           object-fit: cover;
//           display: block;
//           border-radius: 20%;
//         }
        
//         /* Message Content */
//         .message-content {
//           flex: 1;
//           padding: 2rem;
//           display: flex;
//           flex-direction: column;
//         }
        
//         .message-content h3 {
//           color: var(--primary-color);
//           font-size: 1.5rem;
//           margin-bottom: 0.5rem;
//         }
        
//         .message-content h4 {
//           color: var(--dark-text);
//           font-size: 1.2rem;
//           margin-bottom: 0.3rem;
//         }
        
//         .message-content .position {
//           color: var(--secondary-color);
//           font-weight: 600;
//           font-size: 0.9rem;
//           margin-bottom: 1.5rem;
//         }
        
//         /* Message Text */
//         .message-text {
//           flex-grow: 1;
//           color: #555;
//           line-height: 1.7;
//         }
        
//         .message-text p {
//           margin-bottom: 1rem;
//         }
        
//         /* Message Signature */
//         .message-signature {
//           margin-top: 1.5rem;
//           padding-top: 1rem;
//           border-top: 1px solid #eee;
//           font-style: italic;
//           color: #666;
//           font-size: 0.9rem;
//         }
        
//         .message-signature p {
//           margin-bottom: 0.3rem;
//         }
        
//         /* Responsive Design */
//         @media (max-width: 992px) {
//           .section-title {
//             font-size: 1.8rem;
//           }
          
//           .message-content-wrapper {
//             min-height: 300px;
//           }
//         }
        
//         @media (max-width: 768px) {
//           .section-title {
//             font-size: 1.6rem;
//             padding-left: 0;
//           }
          
//           .title-decorator {
//             display: none;
//           }
          
//           .desk-message,
//           .reverse-layout .message-content-wrapper {
//             flex-direction: column;
//           }
          
//           .message-content-wrapper {
//             flex-direction: column;
//             min-height: auto;
//           }
          
//           .member-img-container {
//             min-height: 250px;
//             min-width: 100%;
//           }
          
//           .message-content {
//             padding: 1.5rem;
//           }
          
//           .message-content h3 {
//             font-size: 1.3rem;
//           }
          
//           .message-content h4 {
//             font-size: 1.1rem;
//           }
//         }
        
//         @media (max-width: 576px) {
//           .section-title {
//             font-size: 1.4rem;
//             margin-bottom: 1.5rem;
//           }
          
//           .desk-messages-container {
//             gap: 2rem;
//             padding: 0 0.5rem;
//           }
          
//           .message-content {
//             padding: 1.2rem;
//           }
          
//           .message-text {
//             font-size: 0.95rem;
//           }
          
//           .message-signature {
//             font-size: 0.85rem;
//           }

//           .board-section {
//           margin: 100px 0;
//           background: var(--light-bg);
//           padding: 60px 40px;
//           border-radius: 20px;
//           position: relative;
//           overflow: hidden;
//         }
        
//         .board-section:before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 5px;
//           background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
//         }
        
//         .board-banner {
//           margin: 50px 0;
//           text-align: center;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: var(--card-shadow);
//         }
        
//         .board-banner img {
//           width: 100%;
//           height: auto;
//           display: block;
//           transition: transform 0.5s ease;
//         }
        
//         .board-banner:hover img {
//           transform: scale(1.02);
//         }
        
//         .board-names-container {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 60px;
//           justify-content: center;
//           margin-top: 40px;
//         }
        
//         .board-names-column {
//           flex: 1;
//           min-width: 300px;
//         }
        
//         .board-names {
//           list-style: none;
//           padding: 0;
//           margin: 0;
//         }
        
//         .board-names li {
//           padding: 15px 0;
//           border-bottom: 1px solid #eee;
//           font-size: 1.05rem;
//           position: relative;
//           padding-left: 30px;
//           transition: var(--transition);
//         }
        
//         .board-names li:hover {
//           transform: translateX(5px);
//         }
        
//         .board-names li:before {
//           content: '';
//           position: absolute;
//           left: 0;
//           top: 22px;
//           width: 12px;
//           height: 12px;
//           background: var(--secondary-color);
//           border-radius: 50%;
//         }
        
//         .name {
//           font-weight: 600;
//           color: var(--primary-color);
//         }
//         }
//       `}</style>
//     </>
//   );
// };

// export default BoardManagement;









import React from "react";
import Navbar from "./Header";
import Footer from "./Footer";

const BoardManagement = () => {
  return (
    <>
      <Navbar />
      
      <div className="about-container">
        {/* Key Management Section */}
        <section className="management-section">
          <h2 className="section-title">
            <span className="title-decorator"></span>
            Key Management
          </h2>
          
          <div className="desk-messages-container">
            {/* Chairman's Message */}
            <div className="desk-message">
              <div className="message-content-wrapper">
                <div className="member-img-container">
                  <div className="image-frame">
                    <img src={require('../assets/Picture2.png')} alt="Shri Niranjan S Narasagoudar" />
                  </div>
                </div>
                <div className="message-content">
                  <div className="message-header">
                    <h3>From Chairman's Desk</h3>
                    <h4>Shri. Niranjan S Narasagoudar</h4>
                    <p className="position">Chairman, ASVEM School Shedbal</p>
                  </div>
                  <div className="message-text">
                    <p>We truly believe that education does not end in the class room, we take it beyond classroom. We create an environment that is exciting for our students to enhance learning opportunity. Keeping several learning methods in mind – we have upgraded our infrastructure, campus, added class rooms and improved our library and laboratories.</p>
                    <p>We have an excellent faculty helping us to make a brilliant learning community for our students. Their expertise and dedication towards quality education and experiential learning has been preparing our children to become innovative, notable thinkers and enthused learners.</p>
                  </div>
                  <div className="message-signature">
                    <p><strong>Best Regards</strong></p>
                    <p>Shri. Niranjan Narasagoudar | Chairman, ASVEM School Shedbal</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Secretary's Message */}
            <div className="desk-message reverse-layout">
              <div className="message-content-wrapper">
                <div className="member-img-container">
                  <div className="image-frame">
                    <img src={require('../assets/Picture3.png')} alt="Shri Bahubali Sidnale" />
                  </div>
                </div>
                <div className="message-content">
                  <div className="message-header">
                    <h3>From Secretary's Desk</h3>
                    <h4>Shri. Bahubali Sidnale</h4>
                    <p className="position">Secretary, ASVEM School Shedbal</p>
                  </div>
                  <div className="message-text">
                    <p>I feel fortunate to be a part of ASVEM School committee. My heart is filled with immense pleasure as I perceive the progress being made by the school. We just believe in complete education for your children encompassing academics, co-curricular activities, sports education and life skills learning.</p>
                    <p>My sincere advice to all the students that they have to work hard to face the global competition to survive. I request the teachers to maintain the team spirit and continue their efforts in giving the best to the students.</p>
                  </div>
                  <div className="message-signature">
                    <p><strong>Best Wishes</strong></p>
                    <p>Shri. Bahubali Sidnale | Secretary, ASVEM School Shedbal</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Vice-Chairman's Message */}
            <div className="desk-message">
              <div className="message-content-wrapper">
                <div className="member-img-container">
                  <div className="image-frame">
                    <img src={require('../assets/Picture4.png')} alt="Shri Dadasaheb Patil" />
                  </div>
                </div>
                <div className="message-content">
                  <div className="message-header">
                    <h3>From Vice-Chairman's Desk</h3>
                    <h4>Shri. Dadasaheb Patil</h4>
                    <p className="position">Vice-Chairman, ASVEM School Shedbal</p>
                  </div>
                  <div className="message-text">
                    <p>It is with great pleasure that I welcome you to ASVEM School family. As Vice Chairman, I am deeply committed to ensuring that our school continues to be a place where students can flourish academically and personally.</p>
                    <p>Our mission is to provide a nurturing and stimulating environment where every student feels empowered to reach their full potential. We look forward to working in partnership with parents and faculty to build a brighter future for our students and our school.</p>
                  </div>
                  <div className="message-signature">
                    <p><strong>Best Regards</strong></p>
                    <p>Shri. Dadasaheb Patil | Vice-Chairman, ASVEM School Shedbal</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Principal's Message */}
            <div className="desk-message reverse-layout">
              <div className="message-content-wrapper">
                <div className="member-img-container">
                  <div className="image-frame">
                    <img src={require('../assets/Picture5.jpg')} alt="Mrs. Paddubai S K" />
                  </div>
                </div>
                <div className="message-content">
                  <div className="message-header">
                    <h3>From Principal's Desk</h3>
                    <h4>Mrs. Paddubai S K</h4>
                    <p className="position">Principal, ASVEM School Shedbal</p>
                  </div>
                  <div className="message-text">
                    <p>Education is an investment, and one of the most critical investments we can make. We live in a very challenging time where the world from the education window is changing like never before.</p>
                    <p>At Acharya Shree Vidyanand English Medium School, we believe in a joyful experiential learning system wherein, each child is encouraged to participate wholeheartedly! We approach and imbibe the learning with global outlook and analytical thinking.</p>
                  </div>
                  <div className="message-signature">
                    <p><strong>Best Wishes</strong></p>
                    <p>Mrs. Paddubai S K | Principal, ASVEM School Shedbal</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Board of Management Section */}
        <section className="board-section">
          <h2 className="section-title">
            <span className="title-decorator"></span>
            Board of Management
          </h2>
          
          <div className="board-banner">
            <div className="banner-overlay"></div>
            <img src={require('../assets/Picture7.png')} alt="Board of Management" />
          </div>
          
          <div className="board-names-container">
            <div className="board-names-column">
              <ul className="board-names">
                <li>
                  <span className="name">Shri Niranjan Narasagoudar</span>
                  <span className="role-badge">Chairman</span>
                </li>
                <li>
                  <span className="name">Shri Dadasaheb Patil</span>
                  <span className="role-badge">Vice Chairman</span>
                </li>
                <li>
                  <span className="name">Shri Bahubali Sidnale</span>
                  <span className="role-badge">Secretary</span>
                </li>
                <li>
                  <span className="name">Shri Shantinath Malaganve</span>
                  <span className="role-badge">Member</span>
                </li>
                <li>
                  <span className="name">Shri Roopesh Chougala</span>
                  <span className="role-badge">Member</span>
                </li>
                <li>
                  <span className="name">Shri Dhanyakumar Chougala</span>
                  <span className="role-badge">Member</span>
                </li>
                <li>
                  <span className="name">Shri Udaykumar Savadatti</span>
                  <span className="role-badge">Member</span>
                </li>
              </ul>
            </div>
            
            <div className="board-names-column">
              <ul className="board-names">
                <li>
                  <span className="name">Shri Sachin Lagare</span>
                  <span className="role-badge">Member</span>
                </li>
                <li>
                  <span className="name">Shri Deepak Lagare</span>
                  <span className="role-badge">Member</span>
                </li>
                <li>
                  <span className="name">Shri Pradeep Patil</span>
                  <span className="role-badge">Member</span>
                </li>
                <li>
                  <span className="name">Shri Sanjay Dargaj</span>
                  <span className="role-badge">Member</span>
                </li>
                <li>
                  <span className="name">Shri Sunil Iraj</span>
                  <span className="role-badge">Member</span>
                </li>
                <li>
                  <span className="name">Shri Praveen Patil</span>
                  <span className="role-badge">Member</span>
                </li>
                <li>
                  <span className="name">Shri Anandkumar Narasagoudar</span>
                  <span className="role-badge">Member</span>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>

      <Footer />

      <style>{`
        /* Base Styles */
        :root {
          --primary-color: #0f2b6e;
          --secondary-color: #f9a826;
          --accent-color: #4a6fdc;
          --light-bg: #f9fafc;
          --dark-text: #333;
          --light-text: #fff;
          --card-shadow: 0 10px 30px rgba(0,0,0,0.1);
          --transition: all 0.3s ease;
        }
        
        /* Section Title */
        .section-title {
          font-size: 2.5rem;
          color: var(--primary-color);
          margin: 3rem 0;
          position: relative;
          text-align: center;
          font-weight: 700;
        }
        
        .title-decorator {
          position: absolute;
          left: 50%;
          bottom: -15px;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: var(--secondary-color);
          border-radius: 2px;
        }
        
        /* Desk Messages Container */
        .desk-messages-container {
          display: flex;
          flex-direction: column;
          gap: 4rem;
          margin: 0 auto;
          max-width: 1200px;
          padding: 0 2rem;
        }
        
        /* Desk Message Card */
        .desk-message {
          background: white;
          border-radius: 15px;
          overflow: hidden;
          box-shadow: var(--card-shadow);
          transition: var(--transition);
        }
        
        .desk-message:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 40px rgba(0,0,0,0.15);
        }
        
        /* Message Content Wrapper */
        .message-content-wrapper {
          display: flex;
          min-height: 400px;
        }
        
        /* Reverse layout for alternating pattern */
        .reverse-layout .message-content-wrapper {
          flex-direction: row-reverse;
        }
        
        /* Member Image Container */
        .member-img-container {
          flex: 1;
          min-width: 45%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
          background: linear-gradient(135deg, rgba(15,43,110,0.05) 0%, rgba(249,168,38,0.03) 100%);
        }
        
        .image-frame {
          width: 450px;
          height: 450px;
          border-radius: 30%;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        }
        
        .image-frame img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.5s ease;
        }
        
        .desk-message:hover .image-frame img {
          transform: scale(1.05);
        }
        
        /* Message Content */
        .message-content {
          flex: 1;
          padding: 3rem;
          display: flex;
          flex-direction: column;
        }
        
        .message-header {
          margin-bottom: 2rem;
        }
        
        .message-content h3 {
          color: var(--primary-color);
          font-size: 1.8rem;
          margin-bottom: 0.5rem;
          font-weight: 600;
        }
        
        .message-content h4 {
          color: var(--dark-text);
          font-size: 1.4rem;
          margin-bottom: 0.5rem;
          font-weight: 500;
        }
        
        .message-content .position {
          color: var(--secondary-color);
          font-weight: 600;
          font-size: 1rem;
          margin-bottom: 0;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        
        /* Message Text */
        .message-text {
          flex-grow: 1;
          color: #555;
          line-height: 1.8;
          font-size: 1.1rem;
        }
        
        .message-text p {
          margin-bottom: 1.5rem;
        }
        
        /* Message Signature */
        .message-signature {
          margin-top: 2rem;
          padding-top: 1.5rem;
          border-top: 1px solid #eee;
          font-style: italic;
          color: #666;
          font-size: 0.95rem;
        }
        
        .message-signature p {
          margin-bottom: 0.3rem;
        }
        
        .message-signature strong {
          color: var(--primary-color);
        }
        
        /* Board of Management Section */
        .board-section {
          margin: 6rem 0;
          background: var(--light-bg);
          padding: 4rem 2rem;
          border-radius: 20px;
          position: relative;
          overflow: hidden;
     
        }
        
        .board-section:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 500%;
          height: 5px;
          {/* background: linear-gradient(90deg, var(--primary-color), var(--secondary-color)); */}
        }
        
        .board-banner {
          margin: 3rem 0;
          text-align: center;
          border-radius: 15px;
          overflow: hidden;
          {/* box-shadow: var(--card-shadow); */}
          position: relative;
               display: flex;
          justify-content: center;
        }
        
        .banner-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 50%;
          height: 50%;
          {/* background: linear-gradient(to bottom, rgba(15,43,110,0.2), rgba(15,43,110,0.1)); */}
               display: flex;
          justify-content: center;
        }
        
        .board-banner img {
          width: 60%;
          height: auto;
          display: block;
          transition: transform 0.5s ease;
        }
        
        .board-banner:hover img {
          transform: scale(1.03);
        }
        
        .board-names-container {
          display: flex;
          flex-wrap: wrap;
          gap: 4rem;
          justify-content: center;
          margin-top: 3rem;
              padding: 0 60px 0 60px;
        }
        
        .board-names-column {
          flex: 1;
          min-width: 350px;
        }
        
        .board-names {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .board-names li {
          padding: 1.2rem 1.5rem;
          margin-bottom: 1rem;
          background: white;
          border-radius: 10px;
          box-shadow: 0 3px 10px rgba(0,0,0,0.05);
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: var(--transition);
        }
        
        .board-names li:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        }
        
        .name {
          font-weight: 600;
          color: var(--primary-color);
          font-size: 1.1rem;
        }
        
        .role-badge {
          background: var(--secondary-color);
          color: white;
          padding: 0.3rem 0.8rem;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 500;
        }
        
        /* Responsive Design */
        @media (max-width: 1200px) {
          .message-content-wrapper {
            min-height: 350px;
          }
          
          .image-frame {
            width: 250px;
            height: 250px;
          }
        }
        
        @media (max-width: 992px) {
          .section-title {
            font-size: 2.2rem;
          }
          
          .message-content {
            padding: 2rem;
          }
          
          .message-content h3 {
            font-size: 1.6rem;
          }
          
          .message-content h4 {
            font-size: 1.2rem;
          }
          
          .message-text {
            font-size: 1rem;
          }
        }
        
        @media (max-width: 768px) {
          .section-title {
            font-size: 2rem;
          }
          
          .desk-messages-container {
            padding: 0 1rem;
            gap: 3rem;
          }
          
          .message-content-wrapper,
          .reverse-layout .message-content-wrapper {
            flex-direction: column;
          }
          
          .member-img-container {
            min-height: auto;
            padding: 2rem;
          }
          
          .image-frame {
            width: 200px;
            height: 200px;
          }
          
          .board-names-column {
            min-width: 100%;
          }
        }
        
        @media (max-width: 576px) {
          .section-title {
            font-size: 1.8rem;
          }
          
          .desk-messages-container {
            gap: 2rem;
            padding: 0;
          }
          
          .message-content {
            padding: 1.5rem;
          }
          
          .message-content h3 {
            font-size: 1.4rem;
          }
          
          .message-content h4 {
            font-size: 1.1rem;
          }
          
          .board-section {
            padding: 3rem 1rem;
          }
          
          .board-names li {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.5rem;
          }
          
          .role-badge {
            align-self: flex-end;
          }
        }
      `}</style>
    </>
  );
};

export default BoardManagement;